import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { WebcamIcon } from '../../icons';
import { AppointmentCard } from '../AppointmentCard';
import { ScheduleModel } from '../../resources/models';
import { ConsultationsService } from '../../services';

export interface PreviousAppointmentsViewProps {
  className?: string;
  onBack: VoidFunction;
}

export const PreviousAppointmentsView: FC<PreviousAppointmentsViewProps> = ({ className, onBack }) => {
  const { t } = useTranslation();

  const [consultations, setConsultations] = useState<ScheduleModel[]>([]);

  useEffect(() => {
    ConsultationsService.getScheduleList('previous')
      .then((data) => {
        setConsultations(data.sort((a, b) => b.startTime.localeCompare(a.startTime)));
      })
      .catch(() => {
        setConsultations([]);
      });
  }, []);

  return (
    <div className={classNames('flex h-full flex-col gap-6', className)}>
      <div className="flex items-center justify-between">
        <div className="typo-link shink-0 whitespace-nowrap p-2 font-semibold text-primary" onClick={onBack}>
          <i className="fa fa-angle-left" />
          <span className="ml-1.5">{t('common.back')}</span>
        </div>
        <h2 className="text-center leading-none">{t('appointments.previousAppointments.title')}</h2>
        <WebcamIcon className="shink-0 text-label" size={24} />
      </div>

      {consultations.length ? (
        <div className="overflw-auto flex flex-1 flex-col gap-2">
          {consultations.map((consultation) => (
            <AppointmentCard key={consultation.id} consultation={consultation} />
          ))}
        </div>
      ) : (
        <div className="flex-center typo-sm flex-1 text-center font-bold text-typo1">
          {t('appointments.previousAppointments.noAppointments')}
        </div>
      )}
    </div>
  );
};
